import { ConnectedTradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay.connect';
import { PendingPanelFooter, PendingPanelHeader } from 'components/secondaryMarket/shared/status/Panel';

export function QuotingStatus({ tabId }: { tabId: string }) {
  return (
    <>
      <PendingPanelHeader>
        <ConnectedTradeWay formId={tabId} />
      </PendingPanelHeader>
      <PendingPanelFooter statusKey="secondaryMarket.sidePanel.label.quoteInProgress" />
    </>
  );
}
